import React from 'react';
import ReactDOM from 'react-dom';
import Board from './Board';

ReactDOM.render(
    <Board />,
    document.getElementById('root')
);
